"use client";

import { ChevronRight } from "@shared/assets/icons";
import { Country, getCountryList } from "@widgets/country-code-selector/api";
import { SelectHTMLAttributes, useEffect, useRef, useState } from "react";

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export function Select({ className, onChange, value, ...props }: SelectProps) {
  const ref = useRef<HTMLSelectElement>(null);
  const [countryList, setCountryList] = useState<Record<string, Country>>();
  const [selectedCountry, setSelectedCountry] = useState<Country>();

  useEffect(() => {
    async function fetchCountryList() {
      const countries = await getCountryList();
      setCountryList(countries);
    }

    fetchCountryList().then();
  }, []);

  useEffect(() => {
    if (!value) return;

    setSelectedCountry(countryList?.[value as string]);
  }, [countryList, value]);

  const NoCountry = () => <div>Carregando...</div>;

  return (
    <div
      className={[
        "w-fit min-w-36 flex items-center gap-4 p-4 relative rounded border border-gray-300 outline outline-0 focus:outline-2 focus:outline-antique-brass-500 bg-white cursor-pointer overflow-hidden",
        className,
      ].join(" ")}
      onClick={() => ref.current?.showPicker()}
      tabIndex={0}
    >
      {!countryList ? (
        <NoCountry />
      ) : (
        <>
          <select
            ref={ref}
            className={"absolute h-[1px] w-full left-0 -bottom-1"}
            onChange={(e) => {
              setSelectedCountry(countryList[e.target.value]);
              onChange?.(e);
            }}
            value={value}
            {...props}
          >
            {Object.entries(countryList).map(([code, country]) => (
              <option key={code} value={code}>
                {country.localName} {country.countryCode}
              </option>
            ))}
          </select>

          <ChevronRight className={"rotate-90 fill-gray-400"} />

          {selectedCountry && (
            <div className={"flex items-center gap-2 self-end"}>
              <div>{selectedCountry.flag}</div>

              <div className={"text-gray-500"}>
                {selectedCountry.countryCode}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
